import { render } from "./PrintProtocol.vue?vue&type=template&id=63947171"
import script from "./PrintProtocol.vue?vue&type=script&lang=js"
export * from "./PrintProtocol.vue?vue&type=script&lang=js"

import "./PrintProtocol.vue?vue&type=style&index=0&id=63947171&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__